import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppSettings } from '../../utils/app-settings';
import {
  IGetShippingByIdResponse,
  IGetShippingPaginatedResponse,
  ISipping,
  ShippingStatus,
  ShippingPriority,
  Driver,
} from '../../interfaces/deliveries.interface';

interface IGetDriversResponse {
  statusCode: number;
  message: string;
  data: Driver[];
}

@Injectable({
  providedIn: 'root',
})

export class DeliveriesService {
  constructor(private http: HttpClient, private appSettings: AppSettings) {}

  getDeliveries(page?: number, pageSize?: number, status?: ShippingStatus, priority?: ShippingPriority, q?: string, driverId?: number): Observable<IGetShippingPaginatedResponse> {
    const params: string[] = [];
    if (page !== undefined) params.push(`page=${page}`);
    if (pageSize !== undefined) params.push(`pageSize=${pageSize}`);
    if (status) params.push(`status=${status}`);
    if (priority) params.push(`priority=${priority}`);
    if (q) params.push(`q=${encodeURIComponent(q)}`);
    if (driverId !== undefined) params.push(`driverId=${driverId}`);
    const url = params.length
      ? `${this.appSettings.deliveries.urls.getDeliveries}?${params.join('&')}`
      : this.appSettings.deliveries.urls.getDeliveries;
    return this.http.get<IGetShippingPaginatedResponse>(url);
  }

  getDeliveryById(id: string): Observable<IGetShippingByIdResponse> {
    return this.http.get<IGetShippingByIdResponse>(
      this.appSettings.deliveries.urls.getDeliveries + '/' + id
    );
  }

  getDriversWithShipments(): Observable<Driver[]> {
    return this.http
      .get<IGetDriversResponse>(this.appSettings.deliveries.urls.getDriversWithShipments)
      .pipe(map((response) => response.data));
  }
}
